import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandList } from 'cmdk';
import { useVirtualizer } from '@tanstack/react-virtual';
import { useInView } from 'react-intersection-observer';
import { LoaderIcon } from '../../icons';
import { cn } from '../../utils';
import { SelectOption } from './option';
export function SelectList({ options, emptyState, search, async, isSelected, onSelect, listClassName, }) {
    const timeoutRef = useRef(null);
    const parentRef = useRef(null);
    const [internalSearch, setInternalSearch] = useState(search?.search ?? '');
    const filteredOptions = search && !async
        ? options.filter(o => o.value.toLowerCase().includes(internalSearch.toLowerCase()))
        : options;
    const isLoading = async?.isLoading ?? false;
    const virtualiser = useVirtualizer({
        count: filteredOptions.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => 44,
        overscan: 5,
    });
    useEffect(() => {
        virtualiser.measure();
    }, []);
    const [ref, inView] = useInView();
    useEffect(() => {
        if (!async || !inView || !async.hasNextPage) {
            return;
        }
        async.fetchNextPage();
    }, [inView]);
    const handleSearch = (value) => {
        if (!search) {
            return;
        }
        setInternalSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        timeoutRef.current = setTimeout(() => {
            search.onSearchChange(value);
            timeoutRef.current = null;
        }, 300);
    };
    return (_jsxs(Command, { filter: (value, searchValue) => {
            if (async) {
                return 1;
            }
            return value.toLowerCase().includes(searchValue.toLowerCase()) ? 1 : 0;
        }, children: [search && (_jsx("div", { className: "p-stack-tight border-b border-border", children: _jsx(CommandInput, { value: internalSearch, onValueChange: handleSearch, placeholder: search.searchPlaceholder ?? 'Search options', className: "w-full p-stack-tight rounded-[10px] text-body-sm text-fg-muted focus:outline-border-focus" }) })), _jsxs(CommandList, { ref: parentRef, className: cn('w-full overflow-auto max-h-75', listClassName), children: [_jsx(CommandGroup, { style: {
                            height: filteredOptions.length ? `${virtualiser.getTotalSize()}px` : 'auto',
                        }, className: "w-full relative", children: virtualiser.getVirtualItems().map((virtualItem) => {
                            const option = filteredOptions[virtualItem.index];
                            return (_jsx(SelectOption, { option: option, isSelected: !!isSelected(option), onSelect: () => onSelect(option), style: {
                                    height: `${virtualItem.size}px`,
                                    transform: `translateY(${virtualItem.start}px)`,
                                } }, option.id));
                        }) }), !timeoutRef.current && (_jsx("div", { ref: ref })), isLoading && filteredOptions.length === 0 && (_jsx("div", { className: "flex px-stack-tight py-stack-tight text-body-sm text-fg-muted justify-center", children: _jsx(LoaderIcon, {}) })), !isLoading && (_jsx(CommandEmpty, { className: "px-stack-tight py-stack text-body-sm text-fg-muted text-center", children: emptyState || 'No results found.' }))] })] }));
}
